import React, { useState } from 'react'
import PropTypes from 'prop-types';
import API from './api';

export const StoreContext = React.createContext(null)

const StoreProvider = ({ children }) => {
  const [modalStatus, setModalStatus] = useState({
    modalActive: false,
    overlayActive: false,
    modalHeaderText: '',
    modalBodyText: <></>,
    modalColors: 'default',
  })
  const [api] = useState(new API('http://8.140.23.228'));
  const store = {
    api: [api],
    modalStatus: [modalStatus, setModalStatus],
  }

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

StoreProvider.propTypes = {
  children: PropTypes.object,
};

export default StoreProvider;
